import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";

const Wrapper = styled.div`
  background-color: #fcfcfc;

  .tab-list {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
  }

  .tab-item {
    position: relative;
    display: inline-block;
    font-weight: bold;
    padding: 20px;
    flex: 1;
    cursor: pointer;
    text-transform: uppercase;
    color: ${theme.colors.gray};
    background-color: ${theme.colors.white};
    text-align: center;

    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background-color: ${theme.colors.gray};
      bottom: 0;
      left: 0;
      z-index: 44;
      box-sizing: border-box;
    }

    &.isActive {
      color: ${theme.colors.primaryStrong};

      &:after {
        height: 5px;
        background-color: ${theme.colors.primary};
        border-radius: 4px 4px 0 0;
      }
    }
  }

  .tab-container {
    display: block;
  }

  .tab-content {
    display: none;

    &.isActive {
      display: block;
      margin-top: 10px;
    }
  }

  @media (max-width: 480px) {
    padding: 5% 5%;
  }
`;

const Tabs = ({ tabItems }) => {
  const [items, setItems] = useState(tabItems);

  function show(event, index) {
    let tabs = items;

    tabs.map((item, item_index) => {
      item.isActive = false;
      if (item_index === index) {
        item.isActive = true;
      }

      return tabs;
    });

    setItems([...tabs]);
  }

  return (
    <Wrapper>
      <ul className="tab-list">
        {items?.map((item, index) => (
          <li
            key={index}
            onClick={(event) => show(event, index)}
            className={`tab-item ${item.isActive ? "isActive" : ""}`}
          >
            <span>{item.name}</span>
          </li>
        ))}
      </ul>

      <div className="tab-container">
        {items?.map((item, index) => (
          <div
            key={index}
            className={`tab-content ${item.isActive ? "isActive" : ""} `}
          >
            {item.content}
          </div>
        ))}
      </div>
    </Wrapper>
  );
};
export default Tabs;
